import React, { useEffect, useState } from "react";
import Card from "components/card";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaBookReader } from "react-icons/fa";
import { IoTime } from "react-icons/io5";
import { setErrorText } from "services/schedule/kindergartenScheduleSlice";
import SelectLesson from "./components/select_lesson";
import SelectTime from "./components/select_time";
import { fetchSchedule } from "services/schedule/kindergartenScheduleSlice";
import { addScheduleDetail } from "services/schedule/kindergartenScheduleSlice";
import { fetchScheduleDetailList } from "services/schedule/kindergartenScheduleSlice";
import Loader from "components/loader";
import { Alert } from "@chakra-ui/react";
import Modal from "components/modal";
import { deleteScheduleDetail } from "services/schedule/kindergartenScheduleSlice";

const KindergartenScheduleAdd = () => {
  const weekdayList = [
    { text: "Даваа", value: 1 },
    { text: "Мягмар", value: 2 },
    { text: "Лхагва", value: 3 },
    { text: "Пүрэв", value: 4 },
    { text: "Баасан", value: 5 },
  ];

  const steps = [
    { label: "Хичээл", icon: <FaBookReader /> },
    { label: "Цаг", icon: <IoTime /> },
  ];

  let { id } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState({});
  const [currentDay, setCurrentDay] = useState(1);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeStepIndex, setActiveStepIndex] = useState(0);
  const kindergartenSchedule = useSelector((state) => {
    return state.kindergartenSchedule;
  });

  useEffect(() => {
    if (id) {
      dispatch(fetchSchedule(id));
      dispatch(fetchScheduleDetailList({ id, currentDay }));
      if (showModal) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "unset";
      }
      return () => {
        document.body.style.overflow = "unset"; // Cleanup on unmount
      };
    } else {
      navigate("/admin/kindergarten_daily");
    }
  }, [id, dispatch, showModal, navigate, currentDay]);

  return (
    <Card extra={"w-full pb-10 p-4 h-screen overflow-x-auto pt-0"}>
      <div className="flex items-center ">
        <div className="mt-4 mr-10 w-1/5"></div>
      </div>
      <div className="flex flex-wrap -mx-3 mb-5">
        <div className="w-full max-w-full px-3 mb-6  mx-auto">
          <div className="relative flex-[1_auto] flex flex-col break-words min-w-0 bg-clip-border rounded-[.95rem] bg-white m-5">
            <div className="relative flex flex-col min-w-0 break-words border border-solid bg-clip-border rounded-2xl border-stone-200 bg-light/30">
              <div className="flex-auto block py-8 pt-6 px-9">
                <div className="overflow-x-auto">
                  <div class="flex flex-row p-2 bg-terapist-normal w-full rounded-lg mb-4">
                    {weekdayList.map((day, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          setCurrentDay(day.value);
                          dispatch(
                            fetchScheduleDetailList({
                              id,
                              currentDay: day.value,
                            })
                          );
                        }}
                        className={`flex-1 p-2 rounded-lg text-center text-white font-bold cursor-pointer hover:bg-terapist-active ${
                          currentDay === day.value
                            ? "bg-terapist-active"
                            : "bg-terapist-normal"
                        }`}
                      >
                        {day.text}
                      </div>
                    ))}
                  </div>
                  <table className="w-full my-0 align-middle text-dark border-neutral-200">
                    <thead className="align-bottom">
                      <tr className="font-semibold text-[0.95rem] text-secondary-dark">
                        <th className="pb-3 text-center min-w-[5px]">№</th>
                        <th className="pb-3 text-center min-w-[100px]">
                          Хичээлийн нэр
                        </th>
                        <th className="pb-3 pr-12 text-center ">Цаг</th>
                      </tr>
                    </thead>
                    <tbody>
                      {kindergartenSchedule.loading && <Loader />}
                      {!kindergartenSchedule.loading &&
                      kindergartenSchedule.error ? (
                        <Alert text={kindergartenSchedule.error} />
                      ) : null}
                      {!kindergartenSchedule.loading &&
                      kindergartenSchedule.scheduleDetailList.length
                        ? kindergartenSchedule.scheduleDetailList.map(
                            (row, index) => (
                              <tr className="border-b border-dashed last:border-b-0">
                                <td className="p-3 text-center ">
                                  {index + 1}
                                </td>
                                <td className="p-3 text-center">
                                  {row.lesson.name}
                                </td>
                                <td className="p-3  text-center">
                                  {row.start_time} - {row.end_time}
                                </td>
                                <td className="p-3 text-center">
                                  <button
                                    onClick={() => {
                                      setDeleteItem(row);
                                      setShowDeleteModal(true);
                                    }}
                                    className="ml-auto relative text-secondary-dark bg-light-dark hover:text-primary flex items-center h-[25px] w-[25px] text-base font-medium leading-normal text-center align-middle cursor-pointer rounded-2xl transition-colors duration-200 ease-in-out shadow-none border-0 justify-center"
                                  >
                                    <span className="flex items-center justify-center p-0 m-0 leading-none shrink-0 ">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="#BB595F"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 32 32"
                                        version="1.1"
                                      >
                                        <path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM21.657 10.344c-0.39-0.39-1.023-0.39-1.414 0l-4.242 4.242-4.242-4.242c-0.39-0.39-1.024-0.39-1.415 0s-0.39 1.024 0 1.414l4.242 4.242-4.242 4.242c-0.39 0.39-0.39 1.024 0 1.414s1.024 0.39 1.415 0l4.242-4.242 4.242 4.242c0.39 0.39 1.023 0.39 1.414 0s0.39-1.024 0-1.414l-4.242-4.242 4.242-4.242c0.391-0.391 0.391-1.024 0-1.414z" />
                                      </svg>
                                    </span>
                                  </button>
                                </td>
                              </tr>
                            )
                          )
                        : null}
                      <tr>
                        <td colSpan={5}>
                          {" "}
                          <button
                            type="button"
                            onClick={() => {
                              setActiveStepIndex(0);
                              setShowModal(true);
                            }}
                            className="linear py-[12px] mt-2 rounded-xl bg-terapist-active px-5 text-base font-medium w-full text-white transition duration-200 hover:bg-terapist-normal active:bg-terapist-bg flex justify-center items-center"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <circle
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="#FFFFFF"
                                strokeWidth="1.5"
                              />
                              <path
                                d="M15 12L12 12M12 12L9 12M12 12L12 9M12 12L12 15"
                                stroke="#FFFFFF"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                              />
                            </svg>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal ? (
        <div>
          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
            <div className="relative mx-auto my-6 w-auto max-w-2xl w-1/2">
              {" "}
              {/* Set to w-1/2 for 50% width */}
              <div className="relative flex w-full flex-col rounded-lg border-0 bg-white shadow-lg outline-none focus:outline-none">
                <div className="pr-4">
                  <button
                    className="float-right ml-auto border-0 p-1 text-3xl font-semibold leading-none text-black outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    ×
                  </button>
                </div>{" "}
                <div className="border-slate-200 flex items-start justify-between rounded-t border-b border-solid p-5">
                  <ol className="flex items-center w-full text-sm font-medium text-center text-gray-500 dark:text-gray-400 sm:text-base">
                    {steps.map((step, index) => (
                      <li
                        key={index}
                        className={`flex md:w-full items-center ${
                          index === activeStepIndex
                            ? "text-blue-600 dark:text-blue-500"
                            : "text-gray-500 dark:text-gray-400"
                        } 
            sm:after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700`}
                      >
                        <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500">
                          {step.icon}
                          <div className="mr-2"></div>
                          {step.label}
                          <svg
                            className="w-3 h-3 ms-2 sm:ms-4 rtl:rotate-180"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 12 10"
                          >
                            <path
                              stroke="currentColor"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="m7 9 4-4-4-4M1 9l4-4-4-4"
                            />
                          </svg>
                        </span>
                      </li>
                    ))}
                  </ol>
                </div>
                {/* Body */}
                <div className="relative max-h-[70vh] flex-auto overflow-y-auto p-6">
                  {" "}
                  {activeStepIndex === 0 ? <SelectLesson /> : <SelectTime />}
                </div>
                {/* Footer */}
                <div className="border-slate-200 flex items-center justify-end rounded-b border-t border-solid p-6">
                  <button
                    className="background-transparent cursor-pointer mb-1 mr-1 px-6 py-2 text-sm font-bold uppercase text-red-400 outline-none transition-all duration-150 ease-linear focus:outline-none"
                    type="button"
                    onClick={() => {
                      if (activeStepIndex === 0) {
                        setShowModal(false);
                      } else {
                        setActiveStepIndex(activeStepIndex - 1);
                      }
                    }}
                  >
                    {activeStepIndex === 0 ? "Хаах" : "Буцах"}
                  </button>
                  <button
                    className="active:bg-terapist-normal cursor-pointer mb-1 mr-1 rounded bg-terapist-active px-6 py-3 text-sm font-bold uppercase text-white shadow outline-none transition-all duration-150 ease-linear hover:shadow-lg focus:outline-none"
                    type="button"
                    onClick={() => {
                      if (activeStepIndex === 0) {
                        if (kindergartenSchedule.data.lessonId === -1) {
                          dispatch(setErrorText("Хичээл сонгоно уу"));
                        } else {
                          setActiveStepIndex(activeStepIndex + 1);
                        }
                      } else {
                        if (
                          kindergartenSchedule.data.start === "" &&
                          kindergartenSchedule.data.end === ""
                        ) {
                          dispatch(
                            setErrorText("Эхлэх болон дуусах цаг сонгоно уу")
                          );
                        } else {
                          const data = {
                            day: currentDay,
                            schedule: kindergartenSchedule.schedule.id,
                            lesson: kindergartenSchedule.data.lessonId,
                            start_time: kindergartenSchedule.data.start,
                            end_time: kindergartenSchedule.data.end,
                          };

                          dispatch(addScheduleDetail(data)).then((response) => {
                            if (response.payload !== undefined) {
                              if (response.payload.status) {
                                setShowModal(false);
                              }
                            }
                          });
                        }
                      }
                    }}
                  >
                    Дараах
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </div>
      ) : null}

      {showDeleteModal ? (
        <Modal
          handleSubmit={() => {
            dispatch(deleteScheduleDetail({ id: deleteItem.id })).then(
              (response) => {
                if (response.payload !== undefined) {
                  if (response.payload.status) {
                    setShowDeleteModal(false);
                    dispatch(fetchScheduleDetailList({ id, currentDay }));
                  }
                }
              }
            );
          }}
          setShowModal={setShowDeleteModal}
          child={
            <p className="text-xl text-navy-700 dark:text-white">
              Та "{deleteItem.lesson.name}"-ыг устгахдаа итгэлтэй байна уу?
              Дараахтай холбоотой бүх зүйл устаж болзошгүй
            </p>
          }
          title="Устгах"
        />
      ) : null}
    </Card>
  );
};

export default KindergartenScheduleAdd;
